import { bl_fi_my_einvoice_tin_update_request_hdr_RowClass } from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";

export class MyEInvoiceTinUpdateRequestHdrContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_tin_update_request_hdr: bl_fi_my_einvoice_tin_update_request_hdr_RowClass = new bl_fi_my_einvoice_tin_update_request_hdr_RowClass();
}